import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/userservice/api/pos/list',
    method: 'post',
    data: data
  });
}
export function fetchDetail(data) {
  return request({
    url: '/userservice/api/pos/detail',
    method: 'post',
    data: data
  });
}
export function fetchDelete(posIds) {
  var data = {
    posIds: posIds
  };
  return request({
    url: '/userservice/api/pos/delete',
    method: 'post',
    data: data
  });
}
export function fetchCreate(data) {
  return request({
    url: '/userservice/api/pos/create',
    method: 'post',
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: '/userservice/api/pos/update',
    method: 'post',
    data: data
  });
}